/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleSourceCategoryFromJSON, ApiSimpleSourceCategoryToJSON, } from './ApiSimpleSourceCategory';
export function ApiListSourceCategoriesResponseFromJSON(json) {
    return ApiListSourceCategoriesResponseFromJSONTyped(json, false);
}
export function ApiListSourceCategoriesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': !exists(json, 'result') ? undefined : (json['result'].map(ApiSimpleSourceCategoryFromJSON)),
    };
}
export function ApiListSourceCategoriesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'result': value.result === undefined ? undefined : (value.result.map(ApiSimpleSourceCategoryToJSON)),
    };
}
